import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { DotsIcon } from 'components/Icons/DotsIcon'
import Dropdown from 'components/v2/Dropdown'
import IconButton from 'components/v2/IconButton'
import List from 'components/v2/List'
import { ILoyaltyCampaignRule } from 'features/Loyalty/types'

interface IRulesActionsProps {
  rule: ILoyaltyCampaignRule
  campaignId: string
}

export const RulesActions = ({ rule, campaignId }: IRulesActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  return (
    <Dropdown.Wrapper noPadding noIndicator right onClickAway={(): void => setOpenDropdown(false)}>
      <IconButton icon={<DotsIcon />} noBorder smallPadding onClick={toggleDropdown} />
      <Dropdown.Content open={isOpenDropdown} noIndicator left noOverflow>
        <List.Container>
          <List.Item noPadding>
            <List.Link to={`/loyalty/campaigns/${campaignId}/rules/${rule.id}/edit`}>
              <FormattedMessage id="loyalty.rewards.list.actions.edit" defaultMessage="Edit" />
            </List.Link>
          </List.Item>
        </List.Container>
      </Dropdown.Content>
    </Dropdown.Wrapper>
  )
}
